import React from "react"
import styled from "@emotion/styled"
import Media from "src/components/Media"
import Section from "src/components/Section"
import TextLockup from "src/components/TextLockup"
import Grid from "src/components/Grid"
import { globals, mq } from "src/styles"

const Wrapper = styled(Section)`
  position: relative;
  overflow: hidden;
  padding-left: 20px;
  padding-right: 20px;
  ${globals.verticalSpacing("padding-top")}

  ${mq.largeAndBelow} {
    padding-bottom: 0px;
  }

  ${mq.extraLargeAndUp} {
    padding-left: 0;
    padding-right: 0;
  }

  ${mq.largerAndUp} {
    .text-new {
      max-width: 37.5rem;
    }
  }
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => hideMobile && "display: none"}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => hideDesktop && "display: none"}
  }
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
`

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0 !important;
`
const AppContainer = styled.div`
  grid-row: ${props =>
      props.imagePositionMobile && "-1"}
  ${mq.mediumAndUp} {
    grid-row: ${props => props.imagePositionMobile && "2"};
  }
  grid-row: auto;
  transform: translateY(10px);
`

const BackgroundImage = styled(Media)`
  width: 100%;
  height: 100%;
`
const AppMedia = styled(Media)`
  width: 100%;
  height: 100%;
  max-width: 280px;
  margin: 0 auto;
  ${mq.largeAndUp} {
    margin: 0;
    margin-left: auto;
  }
`

const StyledGrid = styled(Grid)`
  padding-top: 0;
  padding-bottom: 0;
  gap: 20px !important;
  max-width: 1536px;
  margin: 0 auto;
  ${mq.largeAndUp} {
    gap: 20px 50px !important;
  }
`

const AppPreview = ({
  className,
  nextTheme,
  prevTheme,
  theme,
  spacing,
  hideMobile,
  hideDesktop,
  text,
  appMedia,
  imagePositionMobile,
  media,
  headline,
  headlineSize,
  headlineElement,
  textSize,
  actions,
  alignment,
  isFirstSection,
  extraPadding = false,
  entranceDelay,
  id,
}) => {
  if (!text && !text?.eyebrow && !actions) return null
  if (!alignment) alignment = "left"

  return (
    <Wrapper
      className={className}
      prevTheme={prevTheme}
      setTheme={theme}
      nextTheme={nextTheme}
      alignment={alignment}
      isFirstSection={isFirstSection}
      extraPadding={extraPadding}
      newStyle={true}
      id={id}
      padded={false}
      fullWidth
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      <Background>
        <BackgroundImage
          width={2400}
          media={media}
          fit="cover"
          role="presentation"
        />
      </Background>
      <StyledGrid small="[1]" medium="[5] [5]" large="[4] [6]">
        <AppContainer imagePositionMobile={imagePositionMobile}>
          <AppMedia
            width={768}
            media={appMedia}
            fit="contain"
            role="presentation"
          />
        </AppContainer>
        <TextLockup
          eyebrow={text?.eyebrow}
          newStyle={true}
          text={text?._rawText || text}
          headline={headline}
          headlineSize={headlineSize}
          headlineElement={headlineElement}
          textSize={textSize}
          actions={actions}
          theme={theme}
          alignment={alignment}
          entranceDelay={entranceDelay}
        />
      </StyledGrid>
    </Wrapper>
  )
}

export default AppPreview
